import { onRequest, RequestMethod } from 'common/axios/axios';
import { getApiUrl } from 'common/axios/getApiUrl';

/**
 * 여행 코스 — 다녀온 여행을 남기고, 다른 사람이 따라갑니다.
 *
 * 장소 후기(placeReviewRepository)와 나눈 이유는 대상이 다르기 때문입니다.
 * 저쪽은 장소 하나, 이쪽은 코스 하나입니다. 별점 자격도 다릅니다
 * (코스는 따라해 본 사람만).
 *
 * GET 은 `query`, POST 는 `params` 입니다 — onRequest 가 params 를 body 로
 * 보내기 때문에 GET 에 params 를 쓰면 서버의 @RequestParam 에 아무것도
 * 닿지 않습니다(그리고 onRequest 는 에러를 삼켜서 조용히 빈 목록이 됩니다).
 */
export class TravelCourseRepository {

    /** 다녀온 여행을 코스로. 일정은 서버가 그대로 복사합니다 */
    static create = (params: { meetingId: string; title: string; summary?: string }) => {
        return onRequest({
            url: getApiUrl('travelCourses'),
            method: RequestMethod.POST,
            params,
        })
    }

    /** 이 모임을 코스로 남길 수 있는지 — 화면이 버튼을 보일지 정할 때 */
    static canRegister = (meetingId: string) => {
        return onRequest({
            url: `${getApiUrl('travelCourses')}/can-register`,
            method: RequestMethod.GET,
            query: { meetingId },
        })
    }

    /** 코스 목록. sort 는 popular(따라한 수) · rating · recent */
    static list = (query?: {
        regionId?: string;
        sort?: 'popular' | 'rating' | 'recent';
        page?: number;
        size?: number;
    }) => {
        return onRequest({
            url: getApiUrl('travelCourses'),
            method: RequestMethod.GET,
            query,
        })
    }

    static get = (courseId: string) => {
        return onRequest({
            url: `${getApiUrl('travelCourses')}/${encodeURIComponent(courseId)}`,
            method: RequestMethod.GET,
        })
    }

    /** 담을 수 있는 내 여행 — 이미 담은 여행도 표시해 옵니다 */
    static copyTargets = (courseId: string) => {
        return onRequest({
            url: `${getApiUrl('travelCourses')}/${encodeURIComponent(courseId)}/copy-targets`,
            method: RequestMethod.GET,
        })
    }

    /** 내 여행으로 담기 — 장소를 일괄 등록하고 별점 자격을 얻습니다 */
    static copy = (courseId: string, meetingId: string) => {
        return onRequest({
            url: `${getApiUrl('travelCourses')}/${encodeURIComponent(courseId)}/copy`,
            method: RequestMethod.POST,
            params: { meetingId },
        })
    }

    /** 별점 남기기 — 따라해 본 사람만. 다시 보내면 덮어씁니다 */
    static writeReview = (courseId: string, rating: number, content?: string) => {
        return onRequest({
            url: `${getApiUrl('travelCourses')}/${encodeURIComponent(courseId)}/reviews`,
            method: RequestMethod.POST,
            params: { rating, content },
        })
    }

    static reviews = (courseId: string, page = 1, size = 20) => {
        return onRequest({
            url: `${getApiUrl('travelCourses')}/${encodeURIComponent(courseId)}/reviews`,
            method: RequestMethod.GET,
            query: { page, size },
        })
    }
}
